module.exports = __webpack_public_path__ + "img/DE00014.a283c50c.png";